interface ChannelLabelConfig {
  i18nKey: string;
  defaultLabel: string;
}

export const CHANNEL_LABELS_MAP: Record<string, ChannelLabelConfig> = {
  instagram: { i18nKey: 'globalFilter.conversationChannelLabels.instagram', defaultLabel: 'Instagram' },
  instagramcomments: { i18nKey: 'globalFilter.conversationChannelLabels.instagramcomments', defaultLabel: 'Comentários no Instagram' },
  linkedincomments: { i18nKey: 'globalFilter.conversationChannelLabels.linkedincomments', defaultLabel: 'Comentários no LinkedIn' },
  facebook: { i18nKey: 'globalFilter.conversationChannelLabels.facebook', defaultLabel: 'Facebook' },
  facebookgroups: { i18nKey: 'globalFilter.conversationChannelLabels.facebookgroups', defaultLabel: 'Grupos no Facebook' },
  facebookcomments: { i18nKey: 'globalFilter.conversationChannelLabels.facebookcomments', defaultLabel: 'Comentários no Facebook' },
  twitter: { i18nKey: 'globalFilter.conversationChannelLabels.twitter', defaultLabel: 'X (Twitter)' },
  tumblr: { i18nKey: 'globalFilter.conversationChannelLabels.tumblr', defaultLabel: 'Tumblr' },
  googleplus: { i18nKey: 'globalFilter.conversationChannelLabels.googleplus', defaultLabel: 'Google+' },
  googlemybusinessreviews: { i18nKey: 'globalFilter.conversationChannelLabels.googlemybusinessreviews', defaultLabel: 'Avaliações no Google Meu Negócio' },
  news: { i18nKey: 'globalFilter.conversationChannelLabels.news', defaultLabel: 'Portais' },
  blogs: { i18nKey: 'globalFilter.conversationChannelLabels.blogs', defaultLabel: 'Blogs' },
  youtube: { i18nKey: 'globalFilter.conversationChannelLabels.youtube', defaultLabel: 'YouTube' },
  youtubecomments: { i18nKey: 'globalFilter.conversationChannelLabels.youtubecomments', defaultLabel: 'Comentários no YouTube' },
  foruns: { i18nKey: 'globalFilter.conversationChannelLabels.foruns', defaultLabel: 'Fóruns' },
  comentariosemartigos: { i18nKey: 'globalFilter.conversationChannelLabels.comentariosemartigos', defaultLabel: 'Comentários em Artigos' },
  linkedin: { i18nKey: 'globalFilter.conversationChannelLabels.linkedin', defaultLabel: 'LinkedIn' },
  reclameaqui: { i18nKey: 'globalFilter.conversationChannelLabels.reclameaqui', defaultLabel: 'Reclame Aqui' },
  tv: { i18nKey: 'globalFilter.conversationChannelLabels.tv', defaultLabel: 'TV' },
  radio: { i18nKey: 'globalFilter.conversationChannelLabels.radio', defaultLabel: 'Rádio' },
  impressas: { i18nKey: 'globalFilter.conversationChannelLabels.impressas', defaultLabel: 'Impressas' },
  zapier: { i18nKey: 'globalFilter.conversationChannelLabels.zapier', defaultLabel: 'Zapier' },
  googleplay: { i18nKey: 'globalFilter.conversationChannelLabels.googleplay', defaultLabel: 'Google Play' },
  importeddata: { i18nKey: 'globalFilter.conversationChannelLabels.importeddata', defaultLabel: 'Dados Importados' },
  bluesky: { i18nKey: 'globalFilter.conversationChannelLabels.bluesky', defaultLabel: 'Bluesky' },
  tiktok: { i18nKey: 'globalFilter.conversationChannelLabels.tiktok', defaultLabel: 'TikTok' },
  threads: { i18nKey: 'globalFilter.conversationChannelLabels.threads', defaultLabel: 'Threads' },
};

export const getChannelLabelConfigByValue = (value: string, fallback?: string): ChannelLabelConfig => {
  const normalized = value.trim().toLowerCase();
  return CHANNEL_LABELS_MAP[normalized] || {
    i18nKey: '',
    defaultLabel: fallback || value,
  };
};
